import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SurveyManagementEffects } from './state/survey-management.effects';
import { surveyManagementFeature } from './state/survey-management.feature';
import { ManageSurveyEffects } from './state/manage-survey/manage-survey.effects';
import { manageSurveyFeature } from './state/manage-survey/manage-survey.feature';
import { MentionableUsersEffects } from './state/mentionable-users/mentionable-users.effects';
import { mentionableUsersFeature } from './state/mentionable-users/mentionable-users.feature';
import { ManageSurveyReferenceEffects } from './state/manage-survey-reference/manage-survey-reference.effects';
import { manageSurveyReferenceFeature } from './state/manage-survey-reference/manage-survey-reference.feature';

export const SURVEY_MANAGEMENT_STORE_PROVIDERS = {
  feature: makeEnvironmentProviders([
    provideState(surveyManagementFeature),
    provideState(manageSurveyFeature),
    provideState(mentionableUsersFeature),
    provideState(manageSurveyReferenceFeature),
  ]),
  effects: provideEffects(
    SurveyManagementEffects,
    ManageSurveyEffects,
    MentionableUsersEffects,
    ManageSurveyReferenceEffects,
  ),
};
